export function convertToSnakeCase(input: string): string {
  if (!input) return "";

  return input
    .trim()
    .replace(/([-_ ])/g, "_")
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .toLowerCase();
}
